import { axiosPrivate } from 'app/utils';
import helpers from '../helpers';

export default {
  async getDeliverySubscriptions({ pharmacyId, queryObject }) {
    const query = new URLSearchParams(queryObject).toString();
    const response = await axiosPrivate.get(
      `/pharmacies/${pharmacyId}/delivery-subscriptions?${query}`
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async createDeliverySubscription({ pharmacyId, patientId, payload }) {
    const response = await axiosPrivate.post(
      `/pharmacies/${pharmacyId}/patients/${patientId}/delivery-subscriptions`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },

  async createDeliveryExemption({ pharmacyId, patientId, payload }) {
    const response = await axiosPrivate.post(
      `/pharmacies/${pharmacyId}/patients/${patientId}/delivery-exemptions`,
      payload
    );

    if (response.data.error) helpers.throwError(response.data.error);
    return response.data;
  },
};
